export default __webpack_public_path__ + "static/header-1da423c61b0507a302756c0f9629f96e.jpg";